export const Permissions = Object.freeze({
  USER_READ: "user:read",
  USER_CREATE: "user:create",
  USER_UPDATE: "user:update",
  USER_DELETE: "user:delete",
  ROLE_READ: "role:read",
  ROLE_CREATE: "role:create",
  ROLE_UPDATE: "role:update",
  ROLE_DELETE: "role:delete",
  ROLE_ASSIGN: "role:assign",
  PERMISSION_READ: "permission:read",
  PERMISSION_MANAGE: "permission:manage",
  BRAND_READ: "brand:read",
  BRAND_CREATE: "brand:create",
  BRAND_UPDATE: "brand:update",
  BRAND_DELETE: "brand:delete",
  IP_READ: "ip:read",
  IP_CREATE: "ip:create",
  IP_UPDATE: "ip:update",
  IP_DELETE: "ip:delete",
  TIER_READ: "tier:read",
  TIER_MANAGE: "tier:manage",
  TIER_ASSIGN: "tier:assign",
  WALLET_READ: "wallet:read",
  WALLET_MANAGE: "wallet:manage",
  WALLET_TRANSFER: "wallet:transfer",
  TRANSACTION_READ: "transaction:read",
  TRANSACTION_CREATE: "transaction:create",
  COIN_READ: "coin:read",
  COIN_MANAGE: "coin:manage",
  CASHBACK_READ: "cashback:read",
  CASHBACK_MANAGE: "cashback:manage",
  REDEMPTION_READ: "redemption:read",
  REDEMPTION_MANAGE: "redemption:manage",
  PRODUCT_READ: "product:read",
  PRODUCT_CREATE: "product:create",
  PRODUCT_UPDATE: "product:update",
  PRODUCT_DELETE: "product:delete",
  CATEGORY_READ: "category:read",
  CATEGORY_CREATE: "category:create",
  CATEGORY_UPDATE: "category:update",
  CATEGORY_DELETE: "category:delete",
  ORDER_READ: "order:read",
  ORDER_CREATE: "order:create",
  ORDER_UPDATE: "order:update",
  ORDER_DELETE: "order:delete",
  CARD_READ: "card:read",
  CARD_CREATE: "card:create",
  CARD_UPDATE: "card:update",
  CARD_DELETE: "card:delete",
  CARD_IMPORT: "card:import",
  ADDRESS_READ: "address:read",
  ADDRESS_MANAGE: "address:manage",
  PAYMENT_METHOD_READ: "paymentMethod:read",
  PAYMENT_METHOD_MANAGE: "paymentMethod:manage",
  NOTIFICATION_READ: "notification:read",
  NOTIFICATION_MANAGE: "notification:manage",
  CROSS_PROJECT_READ: "crossProject:read",
  CROSS_PROJECT_MANAGE: "crossProject:manage",
  BO_USER_READ: "boUser:read",
  BO_USER_CREATE: "boUser:create",
  BO_USER_UPDATE: "boUser:update",
  BO_USER_DELETE: "boUser:delete",
  DASHBOARD_VIEW: "dashboard:view",
  DASHBOARD_ANALYTICS: "dashboard:analytics",
  B2B_DASHBOARD_VIEW: "b2b_dashboard:view",
  B2B_DASHBOARD_ANALYTICS: "b2b_dashboard:analytics",
  AUDIT_LOG_READ: "auditLog:read",
  PROJECT_SETTINGS_READ: "projectSettings:read",
  PROJECT_SETTINGS_MANAGE: "projectSettings:manage",
  SYSTEM_SETTINGS_READ: "systemSettings:read",
  SYSTEM_SETTINGS_MANAGE: "systemSettings:manage",
  SYSTEM_EMAIL_MANAGE: "systemEmail:manage",
  SYSTEM_CURRENCY_READ: "systemCurrency:read",
  SYSTEM_CURRENCY_MANAGE: "systemCurrency:manage",
  COUPON_READ: "coupon:read",
  COUPON_CREATE: "coupon:create",
  COUPON_UPDATE: "coupon:update",
  COUPON_DELETE: "coupon:delete",
  B2B_COMPANY_READ: "b2b_company:read",
  B2B_COMPANY_MANAGE: "b2b_company:manage",
  B2B_COMPANY_UPDATE: "b2b_company:update",
  B2B_FINANCE_READ: "b2b_finance:read",
  B2B_FINANCE_MANAGE: "b2b_finance:manage",
  B2B_CATALOG_MANAGE: "b2b_catalog:manage",
  B2B_QUOTE_READ: "b2b_quote:read",
  B2B_QUOTE_MANAGE: "b2b_quote:manage",
  B2B_QUOTE_UPDATE: "b2b_quote:update",
  B2B_ORDER_READ: "b2b_order:read",
  B2B_ORDER_MANAGE: "b2b_order:manage",
  B2B_ORDER_UPDATE: "b2b_order:update",
  B2B_ORDER_OBO: "b2b_order:obo",
  B2B_LOGISTICS_MANAGE: "b2b_logistics:manage",
  B2B_USER_READ: "b2b_user:read",
  B2B_USER_MANAGE: "b2b_user:manage",
  B2B_PRICELIST_READ: "b2b_pricelist:read",
  B2B_PRICELIST_MANAGE: "b2b_pricelist:manage",
  B2B_STOCK_TRANSFER_READ: "b2b_stock_transfer:read",
  B2B_STOCK_TRANSFER_MANAGE: "b2b_stock_transfer:manage",
  B2B_BILLING_READ: "b2b_billing:read",
  B2B_BILLING_MANAGE: "b2b_billing:manage",
  B2B_CONSIGNMENT_READ: "b2b_consignment:read",
  B2B_CONSIGNMENT_MANAGE: "b2b_consignment:manage",
  SUPPLIER_READ: "supplier:read",
  SUPPLIER_CREATE: "supplier:create",
  SUPPLIER_UPDATE: "supplier:update",
  SUPPLIER_DELETE: "supplier:delete",
  WAREHOUSE_READ: "warehouse:read",
  WAREHOUSE_MANAGE: "warehouse:manage",
  PREORDER_READ: "preorder:read",
  PREORDER_MANAGE: "preorder:manage",
  RMA_READ: "rma:read",
  RMA_MANAGE: "rma:manage",
  TICKET_READ: "ticket:read",
  TICKET_MANAGE: "ticket:manage",
  REVIEW_READ: "review:read",
  REVIEW_MANAGE: "review:manage",
  CONTENT_READ: "content:read",
  CONTENT_MANAGE: "content:manage",
  CAMPAIGN_READ: "campaign:read",
  CAMPAIGN_MANAGE: "campaign:manage",
});

export const Roles = Object.freeze({
  SUPER_ADMIN: "superAdmin",
  FINANCE_ADMIN: "financeAdmin",
  USER: "user",
  B2B_ADMIN: "b2bAdmin",
  B2B_WAREHOUSE: "b2bWarehouse",
  B2B_MASTER_CLIENT: "b2bMasterClient",
  B2B_SUB_CLIENT: "b2bSubClient",
  SYSTEM_SERVICE: "systemService",
});
